import styled from '@emotion/styled';

import { cmsLegacyThemeConnector } from '../PageBuilder/redux/connector';

const InfoIconContainer = cmsLegacyThemeConnector(styled.span`
  .fa {
    color: ${props => (props.color ? props.color : props.legacyTheme.colors.greyShade1)};
    font-size: ${props => (props.size ? props.size : '16px')};
    margin-left: ${props => (props.marginLeft ? props.marginLeft : '0px')};

    &:hover {
      color: ${props => props.legacyTheme.colors.brand};
      cursor: pointer;
    }
  }
`);

const InfoIcon = ({ clickHandler, size, color, enabled = true, ...props }) => (
  <InfoIconContainer size={size} color={color} {...props}>
    <i
      role="button"
      aria-label="More Information"
      className="fa fa-info-circle"
      tabIndex={enabled ? 0 : -1}
      onClick={clickHandler}
      onKeyPress={e => {
        if (e.key === 'Enter' || e.key === 'Space') {
          clickHandler();
        }
      }}
    />
  </InfoIconContainer>
);

export default InfoIcon;
